<template>
  <div>
    <!-- <el-radio-group v-model="isCollapse" style="margin-bottom: 20px">
      <el-radio-button :label="false">展开</el-radio-button>
      <el-radio-button :label="true">收起</el-radio-button>
    </el-radio-group> -->
    <el-menu
      default-active="1"
      class="el-menu-vertical-demo"
      @select="changeMenu"
      :collapse="isCollapse"
    >
      <!-- <el-submenu index="1">
        <template slot="title">
          <i class="el-icon-location"></i>
          <span slot="title">导航一</span>
        </template>
        <el-menu-item-group>
          <el-menu-item index="1-1">选项1</el-menu-item>
          <el-menu-item index="1-2">选项2</el-menu-item>
        </el-menu-item-group>
      </el-submenu> -->
      <div v-for="item in menus" :key="item.index">
        <el-submenu
          v-if="item.children && item.children.length"
          :index="item.index"
        >
          <template slot="title">
            <i class="el-icon-location"></i>
            <span slot="title">{{ item.title }}</span>
          </template>
          <el-menu-item-group v-if="item.children && item.children.length">
            <el-menu-item
              v-for="(itn, indn) in item.children"
              :index="itn.index"
              :key="indn"
              >{{ itn.title }}</el-menu-item
            >
          </el-menu-item-group>
        </el-submenu>
        <el-menu-item v-else :index="item.index">
          <i class="el-icon-menu"></i>
          <span slot="title">{{ item.title }}</span>
        </el-menu-item>
      </div>
    </el-menu>
  </div>
</template>

<script>
export default {
  name: 'Home',
  data () {
    return {
      isCollapse: false, // 展开 收取 左侧menu
      menus: [
        { index: '1', title: '工作台' },
        {
          index: '2',
          title: '国家标准审核',
          children: [
            { index: '3', title: '立项阶段' },
            { index: '31', title: '起草阶段' },
            { index: '32', title: '征求意见阶段' }
          ]
        }
      ]
    }
  },
  methods: {
    changeMenu (key, keyPath) {
      console.log(key, keyPath, 'index')
    }
  }
}
</script>

<style lang="scss">
.el-menu-vertical-demo:not(.el-menu--collapse) {
  width: 200px;
  min-height: 400px;
}
</style>



// WEBPACK FOOTER //
// src/views/layout/leftMenu.vue